import { render, staticRenderFns } from "./modalDirinit.vue?vue&type=template&id=5a7b73b8&scoped=true"
import script from "./modalDirinit.vue?vue&type=script&lang=js"
export * from "./modalDirinit.vue?vue&type=script&lang=js"
import style0 from "./modalDirinit.vue?vue&type=style&index=0&id=5a7b73b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b73b8",
  null
  
)

export default component.exports